import React, { useRef, useEffect } from "react"
import lodash from 'lodash';
import apiRequest from "../../../../utils/api.request";
import config from '../../../../config.json'
import {vaccinationApiRequestBody} from "../Utils/vaccinationApiRequestBody"
import { _getErrorMessage } from "../Utils/getErrorMessage"

import InputForm from "../Components/InputForm"
import VerifyOtp from "../Components/VerifyOtp"
import ThankYou from "../Components/ThankYou"
import CancelModal from '../Components/CancelModal';

const get_otp_url = config.covid_vacc_base_url + "v1/send-otp-partner/";
const resend_otp_url = config.covid_vacc_base_url + "v1/resend-otp-partner/";
const verify_associate_jhh_url = config.covid_vacc_base_url + "v1/verify-associate-jhh/";
const jhhValidationRegex = "([A-Z]{4}-[0-9]{4}){1}$";
const otpValidationRegex = "([0-9]{6}){1}$";

const _validateInput = ( input, regex) => {
  const regexTester = new RegExp(regex);
  return regexTester.test(input);
}

const DifferentJhhIdFlow = ({ showCorporateFlow, handleUserJourneyChange, profileDetails, userName, t, callbackAfterOtpVerify, closeWindowOnThankYouDone=false}) => {
  const [newJhhId, _setNewJhhId] = React.useState("");
  const [otp, _setOtp] = React.useState("");
  const [errorJhhIdInput, _setErrorJhhIdInput] = React.useState("");
  const [errorOtpInput, _setErrorOtpInput] = React.useState("");
  const [getOtpError, _setGetOtpError] = React.useState("");
  const [validateOtpError, _setValidateOtpError] = React.useState("");
  const [showCancelButton, _setShowCancelButton] = React.useState(true);
  const [showOtpInput, _setShowOtpInput] = React.useState(false);
  const [showThankYou, _setShowThankYou] = React.useState(false);
  const [cancelClicked, _setCancelClicked] = React.useState(false);
  const [getOtpDisabled, _setGetOtpDisabled] = React.useState(false);
  const [resendOtpDisabled, _setResendOtpDisabled] = React.useState(false);
  const [validateOtpDisabled, _setValidateOtpDisabled] = React.useState(false);
  const otpId = useRef("");

  const [resendOtpCounter, _setResendOtpCounter] = React.useState(0);
  const _isMounted = useRef();

  const handleCancelClicked = () => {
    _setCancelClicked(true);
  }
  
  const handleNoClicked = () => {
    _setCancelClicked(false);
  }

  useEffect(() => {
    if (resendOtpCounter > 0) {
      _isMounted.current = setTimeout(() => {
        _setResendOtpCounter((previousOtpCounter) => previousOtpCounter - 1);
      }, 1000);
    }

    return () => {
      if (_isMounted.current) clearTimeout(_isMounted.current);
    };
  }, [resendOtpCounter]);

  const _handleNewJhhIdInput = (e) => {
    if (e.target.value.length < 10) {
      _setErrorJhhIdInput("");
      _setNewJhhId((e.target.value).toUpperCase());
    } else {
      e.target.value = newJhhId;
    }
  }

  const _handleOtpInput = (e) => {
    if (e.target.value.match(/^[0-9]+$/) !== null || e.target.value === "") {
      _setOtp(e.target.value);
      _setErrorOtpInput("");
      _setValidateOtpError("");
    }
  }

  const _handleGetOtpClick = async () => {
    if(!_validateInput(newJhhId,jhhValidationRegex)){
      _setErrorJhhIdInput("Please enter jhh id in the format ABCD-1234.")
      return;
    }

    _setErrorJhhIdInput("");
    let dataObj = {
      "jhh_id":newJhhId
    }
    dataObj = vaccinationApiRequestBody( dataObj, profileDetails);
    
    _setGetOtpDisabled(true);
    const response = await apiRequest(get_otp_url,dataObj,true);
    _setGetOtpDisabled(false);

    if(lodash.get(response,"status") !== "success") {
      _setGetOtpError(lodash.get(response,"response.data.message","Something went wrong, please try again"));
      // _setErrorJhhIdInput(lodash.get(response,"response.data.message","Something went wrong, please try again"));
      return;
    }

    _setGetOtpError("");
    otpId.current = lodash.get(response,"otp_id");

    _setShowOtpInput(true);
    _setResendOtpCounter(60);
    _setShowCancelButton(false);
  } 
  const _handleResendOtpClick = async () => {
    if(resendOtpDisabled) return;
    let dataObj = {
      "jhh_id":newJhhId,
      "otp_id": otpId.current
    }
    dataObj = vaccinationApiRequestBody( dataObj, profileDetails);

    _setResendOtpDisabled(true);
    const response = await apiRequest(resend_otp_url,dataObj,true);
    _setResendOtpDisabled(false);

    if(lodash.get(response,"status") !== "success") {
      _setValidateOtpError(lodash.get(response,"response.data.message","Something went wrong, please try again"));
      return;
    }

    _setValidateOtpError("");
    otpId.current = lodash.get(response,"otp_id");

    _setResendOtpCounter(60);
  }

  const _handleProceedClick = async () => {
    if(!_validateInput(otp,otpValidationRegex)) {
      _setErrorOtpInput("Please enter 6 digit otp.");
      return;
    }

    _setErrorOtpInput("");
    let dataObj = {
      "jhh_id":newJhhId,
      "otp_details": {
        "otp_id": otpId.current,
        "otp": otp
      }
    }
    dataObj = vaccinationApiRequestBody( dataObj, profileDetails);

    _setValidateOtpDisabled(true);
    const response = await apiRequest(verify_associate_jhh_url,dataObj,true);
    _setValidateOtpDisabled(false);

    if(lodash.get(response,"status") !== "success") {
      _setValidateOtpError(lodash.get(response,"response.data.message","Something went wrong, please try again"));
      return;
    }

    _setValidateOtpError("");
    _setResendOtpCounter(0);
    if(callbackAfterOtpVerify){
      callbackAfterOtpVerify()
    }
    _setShowThankYou(true)
  }

  return (
    <div className="different-id-flow-outer-div">
      <div className="express-interest-question">
        <div className="express-interest-left-col">
          <h1 className="express-interest-question-heading">{t("EOI_USE_DIFFERENT_JIOHEALTHHUB_ID")}</h1>
          <div>
            <span className="express-interest-question-description">
            {t("EOI_USE_DIFFERENT_JIOHEALTHHUB_ID_PLEASE_PROVIDE")} <b>{userName}</b> 
            {t("EOI_USE_DIFFERENT_JIOHEALTHHUB_ID_PLEASE_ENSURE")} <b>{userName}</b> 
            <span className="font-red">{t("EOI_USE_DIFFERENT_JIOHEALTHHUB_ID_ASSOCIATION_WARNING")}</span></span>
          </div>
          <br/>
          <a className="express-interest-question-description link" href="https://production.healthhub.net.in/jiohealthhub/login/faq" target="_blank">{t("EOI_GET_JHH_ID")}</a>
          {!showThankYou &&
            <div>
              {showCorporateFlow && 
                <div onClick={() => handleUserJourneyChange("corporate-jhh-id")} className="express-interest-link">
                  {profileDetails.source_relation === "Self" 
                    ? t("EOI_USE_EXISTING_CORPORATE_PROFILE_LINK")
                    : t("EOI_USE_EXISTING_FAMILY_PROFILE_LINK")
                  }
                </div>
              }
              <div onClick={() => handleUserJourneyChange("create-new-jhh-id")} className="express-interest-link">
                {t("EOI_CREATE_NEW_JIOHEALTHHUB_ID_LINK")}
              </div>
            </div>
          }
        </div>
        <div className="express-interest-right-col">
          <InputForm placeholder="Enter JioHealthHub ID" addClassInput={`express-interest-add-input-form${showOtpInput ? " disabled" : " active"}`} label="JioHealthHub ID" readOnly={showOtpInput} type="text" value={newJhhId} onChange={_handleNewJhhIdInput} error={_getErrorMessage(errorJhhIdInput)} />
          {showCancelButton && 
            <div  className="express-interest-different-id-flow-button-flex">
                  <InputForm
                    addClassInput="express-interest-modal-button-yes background-white express-interest-modal-button-padding"
                    type="button"
                    value={t("EOI_CANCEL")}
                    onClick={handleCancelClicked}
                  />
            
                <InputForm
                    addClassInput={`express-interest-modal-button-yes express-interest-modal-button-padding ${getOtpDisabled ? "express-interest-modal-button-disabled" : ""}`}
                    type="button"
                    value={t("EOI_GET_OTP")}
                    disabledValue={getOtpDisabled}
                    onClick={_handleGetOtpClick}
                  />
            </div>
          }
          {(getOtpError && getOtpError.length) && <><p className="form-element-error create-acc-get-otp-error">{_getErrorMessage(getOtpError)}</p></>}
        </div>
      </div>
      {showOtpInput && <VerifyOtp otp={otp} resendOtpCounter={resendOtpCounter} error={_getErrorMessage(errorOtpInput)} validateOtpError={_getErrorMessage(validateOtpError)} validateOtpDisabled={validateOtpDisabled} resendOtpDisabled={resendOtpDisabled} buttonsDisabled={showThankYou} _handleOtpInput={_handleOtpInput} _handleResendOtpClick={_handleResendOtpClick} _handleCancelClick={handleCancelClicked} _handleProceedClick={_handleProceedClick} t={t} />}
      {showThankYou &&
        <ThankYou message={t("EOI_THANK_YOU_COMPONENT_PROFILE_VALIDATION_TEXT")} jhhId={newJhhId} profileDetails={profileDetails} _handleCancelClick={handleCancelClicked} t={t} closeWindowOnThankYouDone={closeWindowOnThankYouDone} />
      }
      {cancelClicked && <CancelModal handleNoClicked={handleNoClicked}/>}

    </div>
  )
}

export default DifferentJhhIdFlow;